export default __webpack_public_path__ + "static/thumb-video3-52a646888100c0e0438b21c377500f17.png";